<template>
  <div
    data-testid="livestorm-event-card"
    class="tw:flex tw:items-center tw:gap-3 tw:px-4 tw:py-3 tw:rounded tw:cursor-pointer tw:transition-all tw:duration-200 tw:min-w-0 tw:max-w-full"
    :class="isLive ? 'tw:bg-red-000 tw:hover:bg-red-100' : 'tw:bg-blue-000 tw:hover:bg-blue-100'"
    @click="$emit('click')"
  >
    <FontAwesomeIcon
      :icon="isLive ? 'fa-solid fa-video' : 'fa-solid fa-graduation-cap'"
      :class="[isLive ? 'tw:text-red-500' : 'tw:text-blue-500', 'tw:text-lg tw:flex-shrink-0']"
    />

    <span
      :class="isLive ? 'tw:text-red-500' : 'tw:text-blue-500'"
      class="tw:body-2--bold tw:whitespace-nowrap tw:flex-shrink-0"
    >
      {{ isLive ? trans._livestorm.live : eventTypeLabel }}
    </span>

    <span class="tw:body-2 tw:text-black tw:truncate tw:flex-1 tw:min-w-0">
      {{ event.title }}
    </span>

    <FontAwesomeIcon
      icon="fa-light fa-arrow-up-right-from-square"
      class="tw:text-default-900 tw:flex-shrink-0 tw:text-xs"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { LiveStormEventInfo } from "./LiveStormEvents.types";

interface Props {
  isLive: boolean;
  event: LiveStormEventInfo;
}

const props = defineProps<Props>();
defineEmits<{
  click: [];
}>();

const trans = window._trans;

const eventTypeLabel = computed(() => {
  const eventTypeLabelMap = {
    webinar: trans._livestorm.newWebinar,
    training: trans._livestorm.newTraining,
    workshop: trans._livestorm.newWorkshop,
  };
  return eventTypeLabelMap[props.event.eventType];
});
</script>
